// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/rd-150x150.jpg"
import img2 from "../Assets/jj-150x150.jpg"



function PostDoctoral() {


    return (
        <div className="min-h-screen bg-white">


            <div className="flex flex-col items-center  min-h-screen p-4 w-full font-serif">
                <p className="font-semibold text-3xl mb-2">
                    Post-doc Alumni
                </p>

                <div className="w-full h-1 bg-cyan m-4"></div>


                <p className="font-semibold text-3xl mb-2">
                    Dr. Rakesh Das
                </p>

                <img
                    src={img1}
                    alt="img1"
                    className="w-48 h-48 rounded shadow mb-4 mt-4" />

                <em className="font-semibold  mb-4 text-black">
                    Dr. Rakesh Das is currently working as a National Post Doctoral Fellow in the SMMEE, IIT Ropar. Before joining here, he was working as a Senior Research Fellow (funded by CSIR, GOI) in the Department of Polymer Science and Technology, University of Calcutta, Kolkata. He was worked on the Ph.D. thesis entitled “Development Of Elastomers From Linseed Oil And Vibration Damping Characterization Through A Fabricated Machine”. In this work, he analyzed vibration damping, shape memory, mechanical, nano-mechanical, dynamic mechanical and microstructures of engineering elastomers and nanocomposites synthesized from linseed oil. His current research interests are mechanical and dynamic mechanical properties of natural structures, soft tissues, bones and also Bionic Engineering, especially dynamics and vibration damping of flying insect.
                </em>

                <div className="w-full h-1 bg-cyan"></div>

                <p className="font-semibold text-3xl mb-2 mt-4">
                    Dr. Jeevan Jyoti
                </p>

                <img
                    src={img2}
                    alt="img1"
                    className="w-48 h-48 rounded shadow mb-4 mt-4" />

                <em className="font-semibold  mb-4 text-black">
                    Dr. Jeevan Jyoti is currently working as a National Post-Doctoral Fellow in the SMMEE, IIT Ropar. She completed her PhD from National Physical Laboratory (CSIR), New Delhi. She worked on large scale synthesis of carbon nanostructures (MWCNTs, RGO and GCNTs) and their advanced nanocomposites for structural applications, body armor materials and efficient EMI shielding materials. She has significantly contributed in creating a facility for large scale synthesis of multiwalled carbon nanotubes using catalytic chemical vapor deposition and developed variety of CNT based composites of significant improved physical and chemical properties. She has also carried out exhaustive studies on mechanical, electrical and thermal properties of MWCNTs reduce graphene oxide and graphene based polymer composites.                    </em>


                <div className="w-full h-1 bg-cyan"></div>





            </div>




        </div>
    );
}

export default PostDoctoral;
